"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _MenuItemCartModal = _interopRequireDefault(require("../../MenuItemCartModal"));

var _menu = _interopRequireDefault(require("../utils/menu"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var MenuCartDisplayItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuCartDisplayItem, _React$Component);

  var _super = _createSuper(MenuCartDisplayItem);

  function MenuCartDisplayItem(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuCartDisplayItem);
    _this = _super.call(this, props);
    _this.state = {
      modalOpen: false
    };
    _this.handleOpen = _this.handleOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getModalOpen = _this.getModalOpen.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuCartDisplayItem, [{
    key: "handleOpen",
    value: function handleOpen() {
      this.setState({
        modalOpen: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        modalOpen: false
      });
    }
  }, {
    key: "getModalOpen",
    value: function getModalOpen() {
      return this.state.modalOpen;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cart = _this$props.cart,
          item = _this$props.item,
          totalPrice = _this$props.totalPrice,
          onRemoveItem = _this$props.onRemoveItem,
          allModifierSets = _this$props.allModifierSets,
          allModifiers = _this$props.allModifiers;
      var name = item.name,
          quantity = item.quantity,
          selectedVariation = item.selectedVariation,
          selectedModifiers = item.selectedModifiers,
          specialInstructions = item.specialInstructions,
          itemModifierSetIds = item.modifierSets;

      var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, allModifierSets);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-cart-item"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-cart-options"
      }, /*#__PURE__*/_react["default"].createElement("div", null, name), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 'bold'
        }
      }, selectedVariation.name !== 'Regular' && selectedVariation.name), selectedModifiers.map(function (_ref) {
        var modifierName = _ref.name,
            price = _ref.price;
        return /*#__PURE__*/_react["default"].createElement("div", null, modifierName, " ", price !== 0 && "+$".concat(price.toFixed(2)));
      }), specialInstructions && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '1rem 0'
        }
      }, "Notes:", specialInstructions), /*#__PURE__*/_react["default"].createElement(_MenuItemCartModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          onClick: this.handleOpen,
          primary: true,
          size: "mini"
        }, "EDIT"),
        type: "update",
        open: this.getModalOpen(),
        onClose: this.handleClose,
        item: item,
        modifiers: allModifiers,
        modifierSets: itemModifierSets,
        variations: _menu["default"].getMenuItemVariations(item),
        cart: cart,
        initialSelectedVariation: selectedVariation,
        initialSelectedModifiers: selectedModifiers,
        initialSpecialInstructions: specialInstructions,
        initialQuantity: quantity
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: onRemoveItem,
        basic: true,
        size: "mini"
      }, "REMOVE")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Label, null, "x", quantity)), /*#__PURE__*/_react["default"].createElement("div", null, "$", totalPrice.toFixed(2))));
    }
  }]);
  return MenuCartDisplayItem;
}(_react["default"].Component);

var _default = MenuCartDisplayItem;
exports["default"] = _default;